<h2 mat-dialog-title>
  <mat-icon class="title-icon">auto_awesome</mat-icon>
  {{ 'WORKCLASSIFICATION.TEMPLATES.APPLY.TITLE' | translate }}
</h2>
<mat-dialog-content class="dialog-container">
  <div class="app-container">
    @if (loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else if (loadFailed()) {
      <p>{{ 'WORKCLASSIFICATION.TEMPLATES.LOAD_FAILED' | translate }}</p>
    } @else if (templates().length === 0) {
      <p>{{ 'WORKCLASSIFICATION.TEMPLATES.APPLY.NO_TEMPLATES' | translate }}</p>
    } @else {
      <mat-form-field appearance="fill">
        <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.APPLY.TEMPLATE' | translate }}</mat-label>
        <mat-icon matPrefix>account_tree</mat-icon>
        <mat-select [value]="selectedId()" (selectionChange)="select($event.value)">
          @for (t of templates(); track t.id) {
            <mat-option [value]="t.id">
              {{ t.name }}@if (t.isDefault) { ({{ 'WORKCLASSIFICATION.TEMPLATES.DEFAULT_BADGE' | translate }}) }
              <span class="text-faint"> · {{ 'WORKCLASSIFICATION.TEMPLATES.EDITOR.META' | translate: { count: t.nodeCount } }}</span>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.APPLY.PREVIEW' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <app-classification-preview [nodes]="previewNodes()"></app-classification-preview>
      </mat-expansion-panel>

      <p class="info-note">
        <mat-icon class="info-icon">info</mat-icon>
        {{ 'WORKCLASSIFICATION.TEMPLATES.APPLY.INFO' | translate }}
      </p>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="btn-secondary" mat-dialog-close>{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-raised-button class="btn-primary" (click)="apply()" [disabled]="!selected() || saving()">
    {{ 'WORKCLASSIFICATION.TEMPLATES.APPLY.CONFIRM' | translate }}
  </button>
</mat-dialog-actions>
